import axios from "axios";
import { getClientID, getURL } from "../redux/selectors";
import store from "../redux/store";

const getSelectorFields = async ({ filters, tablename, keyname, keyvalue, resultfields }) => {
  const state = store.getState();
  const url = getURL(state);
  const clientID = getClientID(state);

  return await axios
    .post(`${process.env.REACT_APP_BACKEND_DOMAIN}/d1services`, {
      url,
      data: {
        service: "selectorFields",
        clientID,
        filters,
        tablename,
        keyname,
        keyvalue,
        resultfields,
        appID: process.env.REACT_APP_SOFTONE_APPID,
      },
    })
    .then((res) => res.data)
    .catch((er) => ({ success: false, error: er.message }));
};

export default getSelectorFields;
